export class APITransformError extends Error {
  constructor(message: string, public method: string) {
    super(message);
    this.name = 'APITransformError';
    this.method = method;
  }
}
